/**
 * Почему кандидат пропал со страницы собеседования.
 *
 * `visibility_hidden` — страница стала невидимой: другая вкладка или свёрнутый браузер.
 * `window_blur` — вкладка, скорее всего, осталась на экране, а фокус ушёл в другое окно.
 */
export type ProctoringAwayReason = "visibility_hidden" | "window_blur";

/**
 * Выбирает причину текущего ухода, если пришло новое событие браузера.
 *
 * Скрытие страницы важнее потери фокуса. Если человек сначала кликнул в другое окно,
 * а потом ушёл на другую вкладку, в отчёте должна остаться скрытая страница,
 * а не два разных ухода.
 */
export function nextAwayReason(
  current: ProctoringAwayReason | null,
  incoming: ProctoringAwayReason,
): ProctoringAwayReason {
  if (current == null) {
    return incoming;
  }

  if (current === "window_blur" && incoming === "visibility_hidden") {
    return "visibility_hidden";
  }

  return current;
}
